// extracted by css-extract-rspack-plugin
export default {"ThreadTitle":"ThreadTitle-module__ThreadTitle__vK9Gi","truncateSnippet":"ThreadTitle-module__truncateSnippet__HZQuw"};